import { Link } from 'react-router-dom';
import {
    SECTION_TWO_HEADING,
    SECTION_TWO_SUBHEADING,
    SUPPORTED_APPS,
} from '../../constants/HomePageConstants';
import './index.css';

export const SupportedApps = () => {

    return (
        <div className="bg-white dark:bg-zinc-800 py-24 sm:py-8">
            <div className="mx-auto max-w-7xl px-4">
                <div className="mx-auto max-w-4xl">
                    <p className="mt-2 text-2xl sm:text-3xl md:text-5xl text-center font-extrabold leading-tight tracking-tight text-balance text-gray-900 dark:text-white">
                        {SECTION_TWO_HEADING}
                    </p>

                </div>
                <p className="mx-auto mt-6 max-w-2xl text-center font-light text-base sm:text-lg md:text-2xl text-gray-500 dark:text-gray-400">
                    {SECTION_TWO_SUBHEADING}
                </p>

                <div className="isolate mx-auto mt-10 grid max-w-md grid-cols-1 gap-8 lg:mx-0 lg:max-w-none sm:grid-cols-2 lg:grid-cols-3">
                    {SUPPORTED_APPS.map(({ id, name, icon, link }) => (
                         <Link to={link} key={id} className="card-link">
                            <div key={id} className="card custom-card">
                                <h3 className="card-title text-gray-900 dark:text-white">{name}</h3>
                                <div className="card-icon">
                                    <img src={icon} className="responsive-icon" alt={`transfer ${name} playlists`} />
                                </div>
                            </div>
                         </Link>
                    ))}
                </div>
            </div>
        </div>
    )
}